import React from 'react';
import { useSelector } from 'react-redux';
import { TARIFFS } from 'constants/Tariffs';
import { selectOnlineForm, selectOnlineFormContract, selectOnlineFormData } from 'stores/onlineForm/onlineForm';
import Content202210 from './Content202210';
import Content202301Oddluzeni from './Content202301Oddluzeni';
import Content202301Sprava from './Content202301Sprava';
import ContentLifeway from './ContentLifeway';
import { Loading } from 'modules';
import Content202607 from './Content202607';

const ContentByContract = () => {
  const form = useSelector(selectOnlineForm);
  const formData = useSelector(selectOnlineFormData);
  const contract = useSelector(selectOnlineFormContract);

  if (!contract || !form || !formData) {
    return <Loading />;
  }

  if (!contract.id_tarif) {
    return null;
  }

  // if (contract.id_tarif === TARIFFS.OBO_JE_2023 || contract.id_tarif === TARIFFS.OBO_MA_2023) {
  //   return <Content202301Oddluzeni contract={contract} form={form} formData={formData} />;
  // }

  if (contract.id_tarif === TARIFFS.OBO_SZ_2023) {
    return <Content202301Sprava contract={contract} form={form} formData={formData} />;
  }

  if (contract.id_tarif === TARIFFS.OBO_LW) {
    return <ContentLifeway />;
  }

  if ([TARIFFS.NZ1, TARIFFS.NZ1MA, TARIFFS.NZ2, TARIFFS.NZ3].includes(contract.id_tarif)) {
    return <Content202607 contract={contract} form={form} formData={formData} />;
  }

  return <Content202210 contract={contract} form={form} />;
};

export default ContentByContract;
